import { useEffect } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ReplyDesk from "./components/ReplyDesk";
import Markets from "./components/Markets";
import HowItWorks from "./components/HowItWorks";
import Demo from "./components/Demo";
import ClientWork from "./components/ClientWork";
import Pricing from "./components/Pricing";
import About from "./components/About";
import ApplyForm from "./components/ApplyForm";
import Footer from "./components/Footer";
import LogoMarquee from "./components/LogoMarquee";

function App() {
  useEffect(() => {
    document.title = "Conduit | Outbound for companies entering new markets";
  }, []);

  return (
    <div className="App grain">
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <ReplyDesk />
        <Markets />
        <HowItWorks />
        <Demo />
        <ClientWork />
        <Pricing />
        <About />
        <ApplyForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
